module.exports = __webpack_public_path__ + "pc/img/main-magazine-img-04.cd6a87f3.png";